// This exists to allow window objects to be mocked.
export const location = window.location;
export const navigator = window.navigator;
export default window;
